export enum TipoCredencial { 'TOKEN', 'LOGIN'}
